// src/components/Dashboard/PolDeductibleNote.jsx
//
// Fila de solo lectura del paso "RS / POL": muestra el deducible que usará la
// SPOL. No se captura en el paso: viene del reclamo (Editar reclamo → Coberturas
// y deducible, importación de Organized o revisión de póliza).
import React from 'react';
import { deductibleDollars, formatMoney } from '../../documents/spolData';

const PolDeductibleNote = ({ claimRecord, language }) => {
  const es = language === 'es';
  const dollars = deductibleDollars(claimRecord);
  const isPercent = claimRecord.deductibleType === 'percentage';
  return (
    <div className={`flow-note pol-deductible${dollars === null ? ' is-missing' : ''}`}>
      <strong>{es ? 'Deducible' : 'Deductible'}:</strong>{' '}
      {dollars === null
        ? (es ? 'falta. Complétalo en Editar reclamo → Coberturas y deducible; la SPOL saldrá con ese campo en blanco.' : 'missing. Add it in Edit claim → Coverages and deductible; the SPOL will leave that field blank.')
        : <>
            {isPercent ? `${claimRecord.deductibleAmount}% = $${formatMoney(dollars)}` : `$${formatMoney(dollars)}`}
            {' '}<span>{es ? '(tomado del reclamo; no se captura aquí)' : '(taken from the claim; not entered here)'}</span>
          </>}
    </div>
  );
};

export default PolDeductibleNote;
